/* ============
 * Actions for the account module
 * ============
 *
 * The actions that are available on the
 * account module.
 */

import * as types from './mutation-types';
import SectionProxy from '../../../proxies/SectionProxy';
import router from '../../../router/index';

export const all = ({ state, commit, rootState }, pageId) => {
  new SectionProxy()
    .setParameters({page_id: pageId})
    .all()
    .then((response) => {
       commit(types.ALL, response.data)
    })
    .catch((error) => {
      console.log(error);
    });
};

export const filter = ({ commit }, slug) => {
  new SectionProxy()
    .find(slug)
    .then((response) => {
      commit(types.FIND, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

export default {
  all,
  filter
};
